<template>
  <oie-product-fraction-wrapper v-if="hasFractions" :is-green="hasSelectedAll && hasFractions" :header="header">
    <template #list>
      <li v-for="fractionType in fractionTypes" :key="fractionType.name" :class="['product-fits__list-item', { 'product-fits__list-item--is-selected': isSelected(fractionType) }]">
        {{ fractionType.description }}
      </li>
    </template>
  </oie-product-fraction-wrapper>
</template>

<script>
import fractionService from '@/core/fraction-service'
import _ from 'lodash'

export default {
  props: {
    productId: {
      type: String,
      required: true
    },
    vehicleName: {
      type: String,
      default: null
    },
    fractions: {
      type: Array,
      default: null
    }
  },
  computed: {
    header() {
      let titleLabel = this.tStatic('titleFractionModel')

      return titleLabel && this.vehicleName ? titleLabel.replace('{0}', this.vehicleName) : null
    },
    fractionTypes() {
      return _.map(fractionService.getItemFractions(this.productId), 'fractionType')
    },
    hasSelectedAll() {
      return fractionService.hasSelectedMatchingFractions(this.productId).matchesOneOfAll
    },
    hasFractions() {
      return this.fractionTypes.length > 0
    }
  },
  created() {
    if (this.fractions !== null) {
      this.$store.dispatch('fractions/setFractions', this.fractions)
    }
    this.$store.dispatch('fractions/setFromQueryParams')
  },
  methods: {
    isSelected(fractionType) {
      // todo: backend should send uuid, we can use name for now:
      return _.some(fractionService.getSelectedItemFractionTypes(this.productId), ft => ft.name === fractionType.name)
    }
  }
}
</script>
